module.exports = __webpack_public_path__ + "static/media/unchecked.0a3284ed.svg";